import instance from "./instancev2";

export function postTagTicket(data) {
  return instance.post(`/ticket/tag`, data);
}

export function putTagTicket(data) {
  return instance.put(`/ticket/tag`, data);
}
